<template>
  <v-container class="pr-0 pl-0" fluid>

    <!-- Row for the first two report cards -->
    <v-row dense>
      <!-- Card for the user report -->
      <v-col cols="12" md="6">
        <v-card class="elevation-10 mt-2" dense :disabled="dialogLoader">
          <v-card-title><v-icon left>mdi-microsoft-excel</v-icon>Relatório de Alunos</v-card-title>
          <v-card-text class="body-1 pb-0">
            Listagem de todos os alunos que treinaram
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary" class="ma-4" dark @click="generateUserTreinosReport">
              Gerar Relatório
              <v-icon right dark>mdi-file-pdf-box</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Card for the user report with all users -->
      <v-col cols="12" md="6">
        <v-card class="elevation-10 mt-2" dense :disabled="dialogLoader">
          <v-card-title><v-icon left>mdi-file-pdf-box</v-icon>Relatório de Todos os Alunos</v-card-title>
          <v-card-text class="body-1 pb-0">
            Listagem de todos os alunos do sistema
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary" class="ma-4" dark @click="generateUserReport">
              Gerar Relatório
              <v-icon right dark>mdi-file-pdf-box</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

    <!-- Card for clients training report based on date range -->
      <v-col cols="12" md="6">
        <v-card class="elevation-10 mt-2" dense :disabled="dialogLoader">
          <v-card-title><v-icon left>mdi-file-pdf-box</v-icon>Relatório de Alunos que Treinaram</v-card-title>
          <v-card-text class="body-1 pb-0">
            <v-row>
              <v-col cols="12">
                Listagem de alunos com treinamento entre as datas selecionadas
              </v-col>

              <!-- Date pickers for the start and end dates -->
              <v-col cols="12" md="6">
                <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="startDate" label="Data Inicial" prepend-icon="mdi-calendar" readonly dense
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" @input="startMenu = false"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="6">
                <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="endDate" label="Data Final" prepend-icon="mdi-calendar" readonly dense
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" @input="endMenu = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary" class="ma-4" dark @click="generateClientsTrainingReport">
              Gerar Relatório
              <v-icon right dark>mdi-file-pdf-box</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    

    <!-- Card for all treinos report based on date range -->
    
      <v-col cols="12" md="6">
        <v-card class="elevation-10 mt-2" dense :disabled="dialogLoader">
          <v-card-title><v-icon left>mdi-file-pdf-box</v-icon>Relatório de Treinos</v-card-title>
          <v-card-text class="body-1 pb-0">
            <v-row>
              <v-col cols="12">
                Listagem de treinos feitos por período
              </v-col>

              <!-- Date pickers for the start and end dates -->
              <v-col cols="12" md="6">
                <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="startDate" label="Data Inicial" prepend-icon="mdi-calendar" readonly dense
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" @input="startMenu = false"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="6">
                <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="endDate" label="Data Final" prepend-icon="mdi-calendar" readonly dense
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" @input="endMenu = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary" class="ma-4" dark @click="generateAllTreinosReport">
              Gerar Relatório
              <v-icon right dark>mdi-file-pdf-box</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Gerando relatório...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>



<script>
//import axios from 'axios';
import HOST from '../ws'

export default {
  data: () => ({
    dialogLoader: false,
    startDate: null,
    endDate: null,
    startMenu: false,
    endMenu: false,
  }),

  methods: {

    generateUserTreinosReport() {
      console.log('Generating user report...');
      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
        .get(HOST.HOST + '/api/reports/users-with-treinos?days=180', {
          responseType: 'blob',
          ...config
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'aluno_treino_report_list.xlsx');
          document.body.appendChild(link);
          link.click();
          this.dialogLoader = false;
        })
        .catch(error => {
          console.error('Error generating the report:', error);
          this.dialogLoader = false;
          this.$store.commit("logout");
          this.$router.push("/");
        });
    },

    generateUserReport() {
      console.log('Generating user report...');
      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
        .get(HOST.HOST + '/api/reports/users', {
          responseType: 'blob',
          ...config
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'aluno_report_list.pdf');
          document.body.appendChild(link);
          link.click();
          this.dialogLoader = false;
        })
        .catch(error => {
          console.error('Error generating the report:', error);
          this.dialogLoader = false;
          this.$store.commit("logout");
          this.$router.push("/");
        });
    },

    generateClientsTrainingReport() {
      if (!this.startDate || !this.endDate) {
        alert('Por favor, selecione as datas de início e fim.');
        return;
      }

      // Pass dates as strings (YYYY-MM-DD format)
      const startDate = this.startDate;
      const endDate = this.endDate;

      console.log('Generating clients training report...');
      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
        .get(HOST.HOST + `/api/reports/clients-training?startDate=${startDate}&endDate=${endDate}`, {
          responseType: 'blob',
          ...config
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'clients_training_report.pdf');
          document.body.appendChild(link);
          link.click();
          this.dialogLoader = false;
        })
        .catch(error => {
          console.error('Error generating the report:', error);
          this.dialogLoader = false;
          this.$store.commit("logout");
          this.$router.push("/");
        });
    }, 

    generateAllTreinosReport() {
      if (!this.startDate || !this.endDate) {
        alert('Por favor, selecione as datas de início e fim.');
        return;
      }

      // Pass dates as strings (YYYY-MM-DD format)
      const startDate = this.startDate;
      const endDate = this.endDate;

      console.log('Generating clients training report...');
      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
        .get(HOST.HOST + `/api/reports/treinos-all?startDate=${startDate}&endDate=${endDate}`, {
          responseType: 'blob',
          ...config
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'treino_report.pdf');
          document.body.appendChild(link);
          link.click();
          this.dialogLoader = false;
        })
        .catch(error => {
          console.error('Error generating the report:', error);
          this.dialogLoader = false;
          this.$store.commit("logout");
          this.$router.push("/");
        });
    }
  }

};
</script>

